<span
	[class.rejected]="result.verification === false"
	[class.restored]="result.verification === true"
	[class.hovered]="isHovered()"
	[title]="'Started at ' + ((result.createdAt - result.microtime / 1000) | date:'HH:mm:ss') + ', EPC: ' + result.startEpc + '\nFinished at ' + (result.createdAt | date:'HH:mm:ss') + ', EPC: ' + result.finishEpc + '\nResult ID: ' + result._id"
>{{result.microtime | laptimeFilter:'minutes'}}</span>
